export class Stage {
  public _id:String;
  public prenom: String;
  public nom:String;
  public sujet:String;
  public description:String;
  public ville:String;
  public universite : String;
  public specialite : String;
  public email : String ;
  public tel : String ;
  public cv : String ;
  public  dateEntretien : Date ;
  public  etat : String ;
  public autre : String ; 
  public date : Date ; 
  constructor(){}
}
